import React from 'react';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';

// THIRD-PARTY IMPORTS
import ReactPaginate from 'react-paginate';

// PAGINATION COMPONENT
const Pagination = ({
  className,
  page = 1,
  totalCount = 0,
  limit = 10,
  isAdvance,
  onPageClick,
  onLimitChange,
  classNameMain,
  firstPageClick,
  lastPageClick,
  onRefreshClick
}) => {
  // PAGINATION OPTIONS
  const options = [
    { value: '10', label: 10 },
    { value: '20', label: 20 },
    { value: '30', label: 30 },
    { value: '40', label: 40 },
    { value: '50', label: 50 },
    { value: '100', label: 100 }
  ];

  const totalPage = Math.ceil(totalCount / limit);
  const start = page * limit - limit + 1;
  const end = isAdvance ? totalCount : Math.min(page * limit, totalCount);

  const handlePageClick = (event) => {
    onPageClick(event.selected + 1);
  };

  const disabledOptions = (val) => {
    if ((end === totalCount && parseInt(val?.value) > limit) || isAdvance) return true;
    return false;
  };

  return (
    <div className={`pagination-container ${totalCount === 0 ? 'center' : ''}`}>
      {totalCount > 0 && (
        <div className={`pagination-info ${classNameMain}`}>
          <span className="pagination-text">{`Showing ${start} to ${end} of ${totalCount} entries`}</span>
          <div className="pagination-limit">
            <select
              value={limit}
              onChange={(e) => onLimitChange(e.target.value)}
              className="pagination-select">
              {options?.map((val, index) => (
                <React.Fragment key={index}>
                  <option disabled={disabledOptions(val)} value={val?.value}>
                    {val?.label}
                  </option>
                </React.Fragment>
              ))}
            </select>
          </div>
          <Icon.RefreshCw size={18} className="cursor-pointer" onClick={onRefreshClick} />
        </div>
      )}
      <div className={`pagination-nav ${classNameMain}`}>
        {totalCount > 0 ? (
          <div className="pagination-prev">
            <button
              className={`pagination-btn ${page === 1 && 'disabled'}`}
              onClick={() => firstPageClick(1)}
              disabled={page === 1}>
              <i className="bi bi-chevron-double-left" />
            </button>
          </div>
        ) : null}
        <ReactPaginate
          containerClassName={`pagination-pages ${className}`}
          pageClassName="pagination-page"
          activeClassName="pagination-active"
          breakLabel=" . . "
          forcePage={page - 1}
          breakClassName="pagination-break"
          nextLabel={
            <label className={`pagination-next-label ${page === totalPage ? 'disabled' : ''}`}>
              Next
            </label>
          }
          nextClassName={`pagination-next ${page === totalPage ? 'disabled' : ''}`}
          onPageChange={handlePageClick}
          pageRangeDisplayed={2}
          pageCount={isAdvance ? 1 : totalPage}
          previousLabel={
            <label className={`pagination-prev-label ${page === 1 ? 'disabled' : ''}`}>
              Previous
            </label>
          }
          previousClassName={`pagination-prev ${page === 1 ? 'disabled' : ''}`}
          renderOnZeroPageCount={null}
        />
        {totalCount > 0 ? (
          <div className="pagination-next">
            <button
              className={`pagination-btn ${page === totalPage && 'disabled'}`}
              onClick={() => lastPageClick(totalPage)}
              disabled={page === totalPage}>
              <i className="bi bi-chevron-double-right" />
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

// PROP TYPES FOR VALIDATION
Pagination.propTypes = {
  className: PropTypes.string,
  page: PropTypes.number,
  totalCount: PropTypes.number,
  limit: PropTypes.number,
  isAdvance: PropTypes.bool,
  onPageClick: PropTypes.func,
  onLimitChange: PropTypes.func,
  classNameMain: PropTypes.string,
  firstPageClick: PropTypes.func,
  lastPageClick: PropTypes.func,
  onRefreshClick: PropTypes.func
};

export default Pagination;
